module.exports = __webpack_public_path__ + "static/media/soviet_dump_120.522996fd.jpg";